export enum DocHitType {
    Normalized,
    Metadata,
    Insights,
    Native,
    Translated
}

export interface DocHit {
    currentHit: number;
    docId: string;
    hitCount: number;
    hitText: string;
    pageNumber: number;
    title: string;
    type: DocHitType;
}
